module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('card-header', {
    attrs: {
      "titulo": ("Aprovação de Férias " + _vm.periodoAquisitivo)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row row-input hidden-xs"
  }, [(_vm.comboUors.length > 1) ? _c('div', {
    staticClass: "col-xs-4 col-sm-3 filter-element"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.uor),
      expression: "filter.uor"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "uor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.buscaFeriasAgendadas(_vm.funcionario, _vm.filter)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Unid. Organ.")]), _vm._v(" "), _vm._l((_vm.comboUors), function(uor) {
    return _c('option', {
      key: uor.id,
      domProps: {
        "value": uor
      }
    }, [_vm._v("\n                        " + _vm._s(uor.sigla) + " - " + _vm._s(uor.codigoCentroCusto) + "\n                      ")])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-sm-3 filter-element"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.status),
      expression: "filter.status"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.buscaFeriasAgendadas(_vm.funcionario, _vm.filter)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Status")]), _vm._v(" "), _vm._l((_vm.comboStatus), function(status) {
    return _c('option', {
      key: status.name,
      domProps: {
        "value": status
      }
    }, [_vm._v("\n                        " + _vm._s(status.displayName &&
      status.displayName.toUpperCase()) + "\n                      ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    staticStyle: {
      "margin-top": "-1px"
    }
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-verde",
      "rotulo": "Limpar",
      "icone": "fa-refresh",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.limpa()
      }
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row row-input visible-xs"
  }, [_c('div', {
    staticClass: "filter-group"
  }, [(_vm.comboUors.length > 1) ? _c('div', {
    staticClass: "filter-field"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.uor),
      expression: "filter.uor"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "uor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.buscaFeriasAgendadas(_vm.funcionario, _vm.filter)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Unid. Organ.")]), _vm._v(" "), _vm._l((_vm.comboUors), function(uor) {
    return _c('option', {
      key: uor.id,
      domProps: {
        "value": uor.sigla
      }
    }, [_vm._v("\n                          " + _vm._s(uor.sigla) + "\n                        ")])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filter-field-button"
  }, [_c('div', {
    staticClass: "filter-field"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.status),
      expression: "filter.status"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.buscaFeriasAgendadas(_vm.funcionario, _vm.filter)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Status")]), _vm._v(" "), _vm._l((_vm.comboStatus), function(status) {
    return _c('option', {
      key: status.name,
      domProps: {
        "value": status
      }
    }, [_vm._v("\n                            " + _vm._s(status.displayName &&
      status.displayName.toUpperCase()) + "\n                          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "filter-button"
  }, [_c('botao', {
    staticStyle: {
      "width": "40px"
    },
    attrs: {
      "estilo": "vazado-verde",
      "rotulo": "",
      "icone": "fa-refresh",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.limpa()
      }
    }
  })], 1)]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', [_c('table-loader', {
    attrs: {
      "carregando": _vm.carregando
    }
  }, [(_vm.agendamentos && !_vm.agendamentos.length) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Você não tem\n                    agendamentos que correspondam com essa busca.\n                  ")]) : _c('div', [_c('table', {
    staticClass: "table table-striped table-hover table-standard"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Dias pendentes")]), _vm._v(" "), (_vm.temMultiplasUors) ? _c('th', [_vm._v("Lotação")]) : _vm._e(), _vm._v(" "), (_vm.temMultiplosAnos) ? _c('th', [_vm._v("Ano")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Início")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.agendamentos), function(ferias) {
    return _c('tr', {
      key: ferias.id,
      class: ferias.statusAprovacao === 'EM_ANALISE' ?
        'situacao-pendente' :
        ''
    }, [_c('td', [_vm._v("\n                            " + _vm._s(ferias.nome.toUpperCase()) + "\n                          ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("\n                            " + _vm._s(ferias.possuiDiasPendentes ? 'SIM' : '') + "\n                          ")]), _vm._v(" "), (_vm.temMultiplasUors) ? _c('td', [_vm._v("\n                            " + _vm._s(ferias.lotacao) + "\n                          ")]) : _vm._e(), _vm._v(" "), (_vm.temMultiplosAnos) ? _c('td', [_vm._v("\n                            " + _vm._s(ferias.ano) + "\n                          ")]) : _vm._e(), _vm._v(" "), (ferias.dataInicioFerias) ? _c('td', [_vm._v("\n                            " + _vm._s(_vm._f("formataData")(ferias.dataInicioFerias)) + "\n                          ")]) : _c('td', [_c('i', {
      staticClass: "fa fa-ellipsis-h fa-lg",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm._f("descricaoStatus")(ferias.statusAprovacao)) + "\n                          ")]), _vm._v(" "), _c('td', {
      staticClass: "td-btns"
    }, [_c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Reprovar'),
        expression: "'Reprovar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": "vazado-vermelho-sm",
        "icone": "fa fa-close fa-lg",
        "disabled": _vm.desabilitaAprovacaoOuReprovacao(ferias)
      },
      on: {
        "clicado": function($event) {
          return _vm.reprovar(ferias)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Aprovar'),
        expression: "'Aprovar'",
        modifiers: {
          "right": true
        }
      }],
      attrs: {
        "estilo": "vazado-verde-sm",
        "icone": "fa fa-check fa-lg",
        "disabled": _vm.desabilitaAprovacaoOuReprovacao(ferias)
      },
      on: {
        "clicado": function($event) {
          return _vm.aprovar(ferias)
        }
      }
    })], 1)])
  }), 0)]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover table-cards"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Agendamentos")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.agendamentos), function(ferias) {
    return _c('tr', {
      key: ferias.id,
      class: ferias.statusAprovacao === 'EM_ANALISE' ?
        'situacao-pendente' :
        ''
    }, [_c('td', [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n                              " + _vm._s(ferias.nome.toUpperCase()) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "legends"
    }, [(_vm.temMultiplasUors) ? _c('div', [_vm._v("Lotação:")]) : _vm._e(), _vm._v(" "), (_vm.temMultiplosAnos) ? _c('div', [_vm._v("Ano:")]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("Férias:")]), _vm._v(" "), _c('div', [_vm._v("Status:")]), _vm._v(" "), _c('div', [_vm._v("Dias pendentes:")])]), _vm._v(" "), _c('div', {
      staticClass: "values"
    }, [(_vm.temMultiplasUors) ? _c('div', [_vm._v("\n                                " + _vm._s(ferias.lotacao) + "\n                              ")]) : _vm._e(), _vm._v(" "), (_vm.temMultiplosAnos) ? _c('div', [_vm._v("\n                                " + _vm._s(ferias.ano) + "\n                              ")]) : _vm._e(), _vm._v(" "), (ferias.dataInicioFerias) ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("formataData")(ferias.dataInicioFerias)) + "\n                              ")]) : _c('div', [_c('i', {
      staticClass: "fa fa-ellipsis-h fa-lg",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("descricaoStatus")(ferias.statusAprovacao)) + "\n                              ")]), _vm._v(" "), _c('div', [_vm._v("\n                                " + _vm._s(ferias.possuiDiasPendentes ? 'SIM' : '') + "\n                              ")])]), _vm._v(" "), _c('div', {
      staticClass: "td-btns actions"
    }, [_c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Reprovar'),
        expression: "'Reprovar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": "vazado-vermelho-sm",
        "icone": "fa fa-close fa-lg",
        "disabled": _vm.desabilitaAprovacaoOuReprovacao(ferias)
      },
      on: {
        "clicado": function($event) {
          return _vm.reprovar(ferias)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Aprovar'),
        expression: "'Aprovar'",
        modifiers: {
          "right": true
        }
      }],
      attrs: {
        "estilo": "vazado-verde-sm",
        "icone": "fa fa-check fa-lg",
        "disabled": _vm.desabilitaAprovacaoOuReprovacao(ferias)
      },
      on: {
        "clicado": function($event) {
          return _vm.aprovar(ferias)
        }
      }
    })], 1)])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-offset-4 col-sm-4 footer-controller-inner footer-center"
  }, [(!_vm.paginacao.ultimo) ? _c('botao', {
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "id": "mais-resultados",
      "tipo": "button",
      "estilo": "vazado-verde-dir",
      "rotulo": "Mais resultados",
      "icone": "fa-chevron-down"
    },
    on: {
      "clicado": function($event) {
        return _vm.listaMaisResultados(_vm.funcionario, _vm.filter)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 footer-controller-inner"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde-dir",
      "rotulo": "Imprimir",
      "icone": "imprimir-tabela"
    },
    on: {
      "clicado": function($event) {
        return _vm.imprime(_vm.funcionario.id, _vm.filter)
      }
    }
  })], 1)])])], 1)], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5",
    staticStyle: {
      "margin-top": "-1px"
    }
  }, [_c('p', {
    staticClass: "alerta"
  }, [_vm._v("\n                    Após aprovação das férias, essa data só poderá ser alterada mediante\n                    abertura de processo administrativo.\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-field"
  }, [_c('p', {
    staticClass: "alerta"
  }, [_vm._v("\n                        Após aprovação das férias, essa data só poderá ser alterada mediante\n                        abertura de processo administrativo.\n                      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-445dd331","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ferias/aprovacao.vue
// module id = zu1O
// module chunks = 5